import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import Modal from '@components/Modal/Modal';

import { IModalConfirmationProps } from './ModalConfirmation.interface';

import './style.scss';

const ModalConfirmation: FC<IModalConfirmationProps> = ({
  open,
  onClose,
  onSubmit,
  isRightActionDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      onClose={onClose}
      open={open}
      className="modal-confirmation"
      isRightActionDisabled={isRightActionDisabled}
      rightActionTitle={t('adminInquiries.submitText')}
      rightActionIcon={<img src="/images/img-submit.svg" />}
      onRightAction={onSubmit}
      leftActionTitle={t('common.cancel')}
      onLeftAction={onClose}
    >
      <Box
        component="img"
        className="modal-confirmation__icon"
        src="/images/img-paperairplane.svg"
      />
      <Box className="modal-confirmation__text">{t('adminInquiries.confirmationText')}</Box>
    </Modal>
  );
};

export default ModalConfirmation;
